<template>
  <div class="merchandise" v-loading="loading">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>智慧餐厅</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="panel">
      <div class="panel-header panel-header__fix">
        <div class="panel-select-group">
          <span class="panel-header__desc">上传引导</span>
        </div>
      </div>
      <div class="panel-body steps">
        <div>
          <p class="step">step<span>1</span></p>
          <p class="step-text">下载批量导入数据所用的 Excel 模板</p>
          <a class="banner-btn" @click="downMode">
            <i class="icon-download"></i>
            <span class="banner-btn__desc">下载模板</span>
          </a>
        </div>
        <div>
          <p class="step">step<span>2</span></p>
          <p class="step-text">仔细阅读模板中说明，按照模板要求填写完模板后，将模板文件拖入下方上传区域</p>
        </div>
        <div>
          <p class="step">step<span>3</span></p>
          <p class="step-text">如模板中有错误数据导致导入失败，请下载错误数据，修改后重新上传</p>
        </div>
        <div>
          <p class="step">step<span>4</span></p>
          <p class="step-text">上传成功的菜品将显示在下面的列表中，点击图片可更换这些图片</p>
        </div>
      </div>
      <div class="panel-body tip" v-if="state">
        <p class="color-green" v-if="uploadInfo.no_error">成功上传 {{ uploadInfo.success }} 件商品</p>
        <div v-else>
          <p class="color-red" >共发现 {{ uploadInfo.fails }} 条错误数据</p>
          <a class="banner-btn" :href="downloadUrl" download>
            <i class="icon-download"></i>
            <span class="banner-btn__desc">下载错误数据</span>
          </a>
        </div>
      </div>
      <div class="panel-body">
        <el-upload
          class="upload-demo"
          v-loading="uploadLoading"
          :on-progress="startAvatarUpload"
          :show-file-list="false"
          :on-success="avatarSuccess"
          :before-upload="avatarBefore"
          :on-error="avatarFailed"
          drag
          :action="uploadUrl"
          accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">请将填写完成的模板文件拖放到此区域,或<em>点击上传</em></div>
        </el-upload>
      </div>

      <div class="panel-body">
        <div class="myform_wrapper">
          <div class="panel">
            <div class="panel-body">
              <el-table
                :data="merchantData.list"
                style="width: 100%"
                row-class-name="el-table__row_fix"
                v-loading="loading">
                <el-table-column label="ID" prop="id" min-width="150"></el-table-column>
                <el-table-column label="图片" min-width="100">
                  <template slot-scope="scope">
                    <img v-if="scope.row.img" :src="scope.row.img" alt="" width="44" height="44" />
                    <el-button v-else size="small" type="primary" class="upload-img">上传图片
                      <input type="file" @change="chooseFile($event, scope.row.unionid, scope.$index)" accept=".png,.jpeg,.jpg,.gif">
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" min-width="150" prop="name">
                </el-table-column>
                <el-table-column label="商品状态">
                  <template slot-scope="scope">
                    <span :class="[ scope.row.available === 1 ? 'color-green' : 'color-orange' ]">{{ scope.row.available_str }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="品类" prop="cate_name">
                </el-table-column>
                <el-table-column label="品类状态" >
                  <template slot-scope="scope">
                    <span :class="[scope.row.cate_available === 1 ? 'color-green' : 'color-orange']">{{ scope.row.cate_available_str }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination_wrapper" v-if="merchantData.count >= 10">
              <el-pagination
                ref="page"
                layout="total, sizes, prev, pager, next, jumper"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                :total="merchantData.count"
                @current-change="currentChange"
                :current-page="currentPage">
              </el-pagination>
            </div>
            <div class="table_placeholder" v-else></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import config from 'config';
  import qs from 'qs';

  export default {
    data() {
      return {
        loading: false,
        uploadLoading: false,
        index: null,
        state: false,
        pageSize: 10,
        currentPage: 1,
        merchantData: {},
        rowInfo: {},
        uploadInfo: {},
        uploadUrl: `${config.host}goods/upload`,
        downloadUrl: `${config.host}/goods/error_download`
      }
    },
    computed: {
      basicParams() {
        return {
          start: this.currentPage - 1,
          length: this.pageSize
        };
      }
    },

    created() {
        this.getData();
    },

    methods: {
      getData() {
        this.loading = true;
        axios.get(`${config.host}/goods/list`, {
          params: this.basicParams
        }).then((res) => {
          this.loading = false;
          let data = res.data;
          if(data.respcd === config.code.OK) {
            this.merchantData = data.data;
          } else {
            this.$message.error(data.resperr);
          }
        }).catch(() => {
          this.loading = false;
          this.$message.error('获取商品列表失败');
        });
      },
      // 改变size
      handleSizeChange(size = 10) {
        this.pageSize = size;
        this.currentChange(1);
      },

      // 改变当前页
      currentChange(current) {
        if (!current && this.currentPage !== 1) {
          this.currentPage = 1;
          return;
        }
        if (current) {
          this.currentPage = current;
          this.getData();
        }
      },

      // 上传之前
      avatarBefore(file) {
        // application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        if (!(/application\/vnd\.(ms-excel|openxmlformats-officedocument.spreadsheetml.sheet)/ig.test(file.type))) {
          this.$message.error('文件格式错误');
          return false;
        }
      },

      // 开始上传
      startAvatarUpload() {
        this.state = false;
        this.uploadLoading = true;
      },

      // 上传成功
      avatarSuccess(res, file) {
        if (res.respcd === config.code.OK) {
          this.state = true;
          this.uploadLoading = false;
          this.$message({
            type: 'success',
            message: '上传成功'
          });
          this.uploadInfo = res.data;
          this.handleSizeChange();
        } else {
          this.uploadLoading = false;
          this.$message.error(res.resperr);
        }
      },

      // 上传失败
      avatarFailed(err, file) {
        this.uploadLoading = false;
        this.$message.error(err);
        console.log(file);
      },

      // 选择图片
      chooseFile(event, uid, index) {
        const {files} = event.target;
        if (files.length > 0) {
          let file = files[0];
          let file0type = file.type;

          if (!file0type) {
            this.$message.error('不能上传非图片');
            return
          }
          if (!(/.\/(jpg|jpeg|png|gif)/ig.test(file0type))) {
            this.$message.error('不能上传非图片');
            return
          }
          this.index = index;
          this.beforeUpload(file, uid);
        }
      },

      // 图片上传，先获取token，key
      beforeUpload(file, uid) {
        axios.get(`https://openapi.qfpay.com/tool/v1/qiniu_token`, {
          params: {
            appcode:	'40F12F92A55747B8AD759E05968A331D',
            func:	'upload',
            format:	'cors'
          }
        }).then((res) => {
          let data = res.data;
          if (data.respcd === config.code.OK) {
            let da = data.data;
            let info = {
              token: da.token,
              key: da.key,
              domain: da.domain
            };
            this.uploadFile(info, file, uid);
          } else {
            this.$message.error('获取七牛token失败');
          }
        }).catch(() => {
          this.$message.error('获取七牛token失败');
        })
      },

      // 图片上传
      uploadFile(info, file, uid) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('token', info.token);
        formData.append('key', info.key);

        axios.post(`https://upload.qiniup.com/`, formData, {
          withCredentials: false
        }).then((res) => {
          if (!res.data.key) {
            this.$message.error('上传失败');
            return false
          }else {
            let url = `${info.domain}/${res.data.key}`;

            axios.post(`${config.host}/goods/setimg`, qs.stringify({
                unionid: uid,
                img: url
              })).then((rp) => {
              let data = rp.data;
              if(data.respcd === config.code.OK) {
                this.$message.success('添加商品图片成功');
                this.merchantData.list[this.index]['img'] = url;
              } else {
                this.$message.error('添加图片失败' + data.resperr);
              }
            }).catch(() => {
              this.$message.error('添加图片失败');
            })

          }

        }).catch(() => {
          this.$message.error('上传七牛失败');
        })
      },

      // 点击下载
      downMode() {
        this.getBlob("https://near.qfpay.com.cn/op_upload/1271319/1541759461617.xlsx").then(blob => {
          this.saveAs(blob, '商品管理模版.xlsx');
        });
      },

      // 转换二进制流
      getBlob(url) {
        return new Promise(resolve => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();
        });
      },

      // 保存本地
      saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');

          link.href = window.URL.createObjectURL(blob);
          link.download = filename;

          // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);

          link.click();
          body.removeChild(link);

          window.URL.revokeObjectURL(link.href);
        }
      }

    }
  };
</script>

<style lang="scss">
  .merchandise {
    .steps {
      display: flex;
      &>div {
        margin: 0 40px;
        flex: 1;
      }
      .step {
        font-size: 20px;
        color: #a7a9ae;
        border-bottom: 2px solid #fe9b20;
        span {
          font-size: 34px;
          margin-left: 5px;
          color: #2f323a;
        }
      }
      .step-text {
        font-size: 15px;
        color: #262424;
        margin-top: 10px;
        line-height: 1.5;
      }
      .banner-btn {
        margin-top: 10px;
      }
    }

    .color-green{
      color: #7ED321;
    }
    .color-orange{
      color: #FE9B20;
    }
    .color-red{
      color: #FF0808;
    }
    .upload-demo {
      padding: 0 40px;

      .el-upload {
        display: block;
      }
      .el-upload-dragger {
        width: 100%;
        border-width: 2px;
      }
    }
    .tip {
      p {
        text-align: center;
        margin: 5px 0;
      }
      a {
        margin: auto;
      }
    }
    .upload-img {
      width: 70px;
      position: relative;
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
    .el-table img {
      border: 1px solid #dedede;
    }
  }

</style>



// WEBPACK FOOTER //
// merchandise.vue?e9f283ea